<template>
  <div class="page boss-page">
    <van-nav-bar title="项目价值清单" left-arrow @click-left="$router.back()"/>
    <section class="toolbar">
      <van-button type="danger" block @click="open()">新增价值检查项</van-button>
    </section>
    <van-empty v-if="!items.length" description="暂无价值检查项"/>
    <article v-for="item in items" :key="item.id">
      <div><b>{{ item.item_name }}</b><small>{{ item.item_code }} · {{ item.item_type }}</small></div>
      <span :class="item.status==='DONE'?'done':''">{{ item.status === 'DONE' ? '已完成' : '待补证据' }}</span>
      <button v-if="item.status!=='DONE'" @click="complete(item)">完成</button>
      <button @click="open(item)">编辑</button>
    </article>
    <van-popup v-model="visible" position="bottom" round class="form"><h3>{{ editing ? '编辑' : '新增' }}价值检查项</h3>
      <van-field v-model="form.itemCode" label="编码"/>
      <van-field v-model="form.itemName" label="检查项"/>
      <van-field v-model="form.itemType" label="类型"/>
      <van-field v-model="form.evidenceReference" label="证据"/>
      <van-button type="danger" block @click="save">保存</van-button>
    </van-popup>
  </div>
</template>
<script>import api from '@/utils/coreapi';

export default {
  data() {
    return {
      items: [],
      visible: false,
      editing: false,
      form: {itemCode: '', itemName: '', itemType: 'VALUE', required: true, status: 'OPEN', evidenceReference: ''}
    }
  }, created() {
    this.load()
  }, methods: {
    async load() {
      try {
        this.items = await api.bossProjectValueChecklist(this.$route.params.id) || []
      } catch (e) {
        this.$toast.fail(e.message)
      }
    }, open(item) {
      this.editing = !!item;
      this.form = item ? {
        itemCode: item.item_code,
        itemName: item.item_name,
        itemType: item.item_type,
        required: item.required_flag,
        status: item.status,
        evidenceReference: item.evidence_reference || ''
      } : {itemCode: '', itemName: '', itemType: 'VALUE', required: true, status: 'OPEN', evidenceReference: ''};
      this.visible = true
    }, complete(item) {
      this.open(item);
      this.form.status = 'DONE'
    }, async save() {
      if (!this.form.itemCode || !this.form.itemName) return this.$toast('请填写编码和名称');
      try {
        await api.saveBossProjectValueChecklist(this.$route.params.id, this.form);
        this.visible = false;
        await this.load();
        this.$toast.success('已保存')
      } catch (e) {
        this.$toast.fail(e.message)
      }
    }
  }
}</script>
<style lang="less" scoped>
@import './boss.less';
.page {
  min-height: 100vh;
  background: #f6f7fb;
  color: #303344;
  padding-bottom: 1rem
}

.toolbar {
  padding: .25rem;
  background: #fff
}

.toolbar .van-button, .form .van-button {
  background: #c62828;
  border-color: #c62828
}

article {
  margin: .2rem .25rem;
  padding: .25rem;
  display: flex;
  align-items: center;
  gap: .12rem;
  background: #fff;
  border-radius: .14rem
}

article div {
  flex: 1
}

article b, article small {
  display: block
}

article b {
  font-size: .3rem
}

article small {
  margin-top: .08rem;
  color: #8b8e9e;
  font-size: .22rem
}

article span {
  color: #b36b00;
  font-size: .23rem
}

article span.done {
  color: #278e56
}

article button {
  padding: .1rem .16rem;
  border: 1px solid #c62828;
  border-radius: .06rem;
  color: #c62828;
  background: #fff;
  font-size: .22rem
}

.form {
  padding: .3rem
}

.form h3 {
  font-size: .34rem;
  margin: 0 0 .15rem
}

.form .van-button {
  margin-top: .25rem
}
.page /deep/ .van-nav-bar {
  margin: 0;
  width: 100%;
  height: 1.22667rem;
  border-radius: 0;
}
article { box-shadow: 0 .06rem .24rem rgba(211,47,47,.08); }
</style>



// WEBPACK FOOTER //
// src/views/boss/ProjectValueChecklist.vue